import moment from 'moment'

import 'moment/locale/id'

moment.locale('en')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
